import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { EnumUserRole } from 'lib/graphql';
import { BaseModule } from 'lib/modules';

// Lazy-loaded page component
const InvoicesPage = lazy(() =>
  import(/* webpackChunkName: "invoices" */ 'pages/invoices').then((m) => ({
    default: m.InvoicesPage,
  })),
);

/**
 * Invoices Module Implementation
 */
class InvoicesModuleClass extends BaseModule {
  id = 'INVOICES';
  name = 'Invoices';
  label = 'Invoices';
  description = 'Invoicing and billing management';
  version = '1.0.0';
  createRoutes = (
    ProtectedRoute: any,
    LazyWrapper: any,
    settings?: any,
    ModuleProtectedRoute?: any,
  ): RouteObject[] => {
    const RouteProtector = ModuleProtectedRoute || ProtectedRoute;

    return [
      {
        path: '/invoices',
        element: (
          <RouteProtector
            component={InvoicesPage}
            moduleId="INVOICES"
            allowedUserRoles={[EnumUserRole.Vendor]}
          />
        ),
      },
    ];
  };
}

// Export singleton instance
export const InvoicesModule = new InvoicesModuleClass();
